export default "__VITE_ASSET__BWNl7UWV__"